module.exports = __webpack_public_path__ + "img/chat.e8c06ce7.svg";